module.exports = __webpack_public_path__ + "static/media/westric.b64578e3.png";